export default "__VITE_ASSET__D$NeQ5IW__"